export const FONTS_NAME = 'Inter Tight';
export const FONT_WEIGHT_LIGHT = 300;
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_MEDIUM = 500;
export const FONT_WEIGHT_BOLD = 600;
export const FONT_SIZE_BASE = 16;
